import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import NavHelper from '../../helper/NavHelper';
import footerlinks from '../../data/footerlinks.json';

class Footer extends NavHelper {
    render() {
        const backToTop = this.state.stickyHeader ? ' d-block' : '';
        return (
            <Fragment>
                {/* Start Footer */}
                <footer className="footer-section">
                    <div className="container">
                        <div className="footer-cta pt-5 pb-5">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="single-cta"> <i className="fas fa-map-marker-alt" />
                                        <div className="cta-text">
                                            <h4>Address</h4>
                                            <span>1010 ram nagar, chandigarh</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="single-cta"> <i className="fas fa-phone" />
                                        <div className="cta-text">
                                            <h4>Contact Us</h4>
                                            <span>0-112-353-788</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 mb-30">
                                    <div className="single-cta"> <i className="far fa-envelope-open" />
                                        <div className="cta-text">
                                            <h4>E-mail Address</h4>
                                            <span>example@example.com</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="footer-content pt-5 pb-5">
                            <div className="row">
                                <div className=" col-lg-4 mb-50 mt-3">
                                    <div className="footer-widget">
                                        <div className="footer-logo"> <Link to="/"><img src={process.env.PUBLIC_URL + "/assets/images/logo.png"} className="img-fluid" alt="logo" /></Link> </div>
                                        <div className="footer-text">
                                            <p>Lorem ipsum dolor sit amet, consec tetur adipisicing elit, sed do eiusmod tempor incididuntut consec tetur adipisicing
                                                elit,Lorem ipsum dolor sit amet.</p>
                                        </div>
                                        <div className="footer-social-icon"> <span>Follow us</span> <Link to="#"><i className="fab fa-facebook-f facebook-bg" /></Link> <Link to="#"><i className="fab fa-twitter twitter-bg" /></Link> <Link to="#"><i className="fab fa-google-plus-g google-bg" /></Link> </div>
                                    </div>
                                </div>
                                <div className=" col-lg-4 col-md-6 mb-30 mt-3">
                                    <div className="footer-widget">
                                        <div className="footer-widget-heading">
                                            <h3>Useful Links</h3>
                                        </div>
                                        <ul>
                                            {/* Data */}
                                            {footerlinks.slice(0, 10).map((item, i) => (
                                                <li key={i}>
                                                    <Link to={item.link}>{item.linkText}</Link>
                                                </li>
                                            ))}
                                            {/* Data */}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 mb-50 mt-3">
                                    <div className="footer-widget">
                                        <div className="footer-widget-heading">
                                            <h3>Subscribe</h3>
                                        </div>
                                        <div className="footer-text mb-25">
                                            <p>Don’t miss to subscribe to our new feeds, kindly fill the form below.</p>
                                        </div>
                                        <div className="subscribe-form">
                                            <form action="#">
                                                <input type="text" placeholder="Email Address" />
                                                <button><i className="fab fa-telegram-plane" /></button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="copyright-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 text-center text-lg-left">
                                    <div className="copyright-text">
                                        <p className="text-custom-white">© Website - 2022 | All Right Reserved.</p>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 d-none d-lg-block text-right">
                                    <div className="footer-menu">
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/about">About</Link></li>
                                            <li><Link to="/contact">Contact</Link></li>
                                            <li><Link to="/blog-grid">blog</Link></li>
                                            <li><Link to="/gallery">Gallery</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                {/* End Footer */}
                <div id="back-top" className={"back-top" + backToTop}>
                    <Link to="#" data-toggle="button" aria-pressed="true" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}><i className="flaticon-arrows" /></Link>
                </div>
            </Fragment>
        );
    }
}

export default Footer;